import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { LokiEffects } from "./+state/effects";
import { LokiService } from "./+state/services";

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([LokiEffects])],
  providers: [LokiService]
})
export class LokiDataAccessModule {}
